export enum ProductOfferType {
    PRODUCT_TYPE_CLASSIC = 'PRODUCT_TYPE_CLASSIC',
    PRODUCT_TYPE_MULTI = 'PRODUCT_TYPE_MULTI',
}

export const PRODUCT_MODES = [
    ProductOfferType.PRODUCT_TYPE_CLASSIC,
    ProductOfferType.PRODUCT_TYPE_MULTI,
];

export class ProductOfferTypeHelper {
    public static isTypeClassic = (mode: ProductOfferType) =>
        mode === ProductOfferType.PRODUCT_TYPE_CLASSIC;
    public static isTypeMulti = (mode: ProductOfferType) =>
        mode === ProductOfferType.PRODUCT_TYPE_MULTI;
}
